module.exports = __webpack_public_path__ + "img/muhdo.de24b018.png";